import React, {FunctionComponent, useState} from 'react';
import {useTranslation} from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import {MetadataCategoryData, MetadataData} from "../../../api/GovernanceToolApi";
import {CategoryAutocomplete, FilterableCategory} from "./CategoryAutocomplete";

export const EditMetadataDialog: FunctionComponent<EditMetadataProps> = props => {
    const {t} = useTranslation();
    const [state, setState] = useState<EditMetadataState>({
        category: props.metadata?.category ?? '',
        value: props.metadata?.value ?? ''
    })

    return <Dialog
        maxWidth="md"
        aria-labelledby="edit-dialog-title"
        open={true}
        onClose={() => props.onCancelClick()}
        sx={{
            '& .MuiFormControl-root': {
                marginTop: '1em'
            }
        }}>
        <DialogTitle
            id="edit-dialog-title">{props.metadata?.id ? t("Edit metadata") : t("Add metadata")}</DialogTitle>
        <DialogContent dividers>
            <CategoryAutocomplete
                label={t("Category")}
                options={props.metadataCategories.map(c => ({value: c.code} as FilterableCategory))}
                setValue={(category) => {
                    setState(state => ({...state, category: category.value}));
                }}
                value={({value: state.category} as FilterableCategory)}
                fullWidth
            />
            <TextField
                variant="outlined"
                label={t("Value")}
                fullWidth
                value={state.value}
                onChange={e => {
                    setState(state => ({...state, value: e.target.value}));
                }}/>
        </DialogContent>
        <DialogActions>
            <Button disabled={!state.category || !state.value}
                    onClick={_ => props.onOkClick(state.category, state.value)}
                    color="primary">
                {props.metadata?.id ? t("Edit") : t("Add")}
            </Button>
            <Button autoFocus
                    onClick={() => props.onCancelClick()}
                    color="primary">
                {t("Cancel")}
            </Button>
        </DialogActions>
    </Dialog>
}

export interface EditMetadataProps {
    metadata: MetadataData;
    metadataCategories: MetadataCategoryData[];

    onCancelClick: () => void;
    onOkClick: (category: string | undefined, value: string | undefined) => void;
}

interface EditMetadataState {
    category: string;
    value: string;
}